import PublicLayout from 'modules/Layouts/PublicLayout';
import ErrorContainer from '../ErrorContainer';

const ErrorMaintenance = (): JSX.Element => (
  <PublicLayout contentCentered isError>
    <ErrorContainer
      title='Технические работы'
      text={
        'Мы проводим плановое обслуживание системы, чтобы всё работало\nбыстрее, стабильнее и надёжнее. Работы займут немного времени.\nПожалуйста, зайдите позже.'
      }
      forceHideHomeLink
      disableLogoLink
    />
  </PublicLayout>
);

export default ErrorMaintenance;
